import { MemberProps } from 'app/components/Core/convention'
import useTranslation from 'app/lib/hooks/useTranslation'

type Props = {
  count: number
  omitCount?: boolean
}
function KUnit({ member, props: { count, omitCount = false } }: MemberProps<IUnit, Props>) {
  const { tComponent } = useTranslation({ componentType: 'data_display', scope: 'unit' })
  if (!member?.name) {
    return null
  }

  if (member.name === 'lump_sum') return tComponent({ id: member.name })
  return [!omitCount && count, tComponent({ id: member.name }, { count })].filter(Boolean).join(' ')
}

export default KUnit
